import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction, Template } from '@ztechapps/common.contract'

@InputType()
export class CreateHaulerTemplateArgs extends ActionArgs {
  /** The catalog row to create; `category` and `scope` are stamped by the Action. */
  @Field(() => GraphQLJSON, { nullable: false })
  input: Partial<Template>
}

export interface ICreateHaulerTemplate extends IAction<Template, CreateHaulerTemplateArgs> {}
